export default __webpack_public_path__ + "static/media/phone.1dbfb7b2.png";